import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import dayjs from "dayjs";
import MainStore from "MainStore";
import { validate, validateField } from "./valid";
import { getorganization_setting } from "api/Organisation_setting";
import { createorganization_setting } from "api/Organisation_setting";
import { updateorganization_setting } from "api/Organisation_setting";

import storeList from "features/Organisation_setting/Organization_settingListView/store"


class NewStore {
  id = 0
  organization_id = 0
  setting_key = ""
  setting_value = ""
  data_type = ""
  description = ""

  errors: { [key: string]: string } = {};

  constructor() {
    makeAutoObservable(this);
  }

  clearStore() {
    runInAction(() => {
      this.setting_key = ""
      this.setting_value = ""
      this.data_type = ""
      this.description = ""
      this.organization_id = 0

      this.errors = {}
    });
  }

  handleChange(event) {
    const { name, value } = event.target;
    (this as any)[name] = value;
    this.validateField(name, value);
  }

  async validateField(name: string, value: any) {
    const { isValid, error } = await validateField(name, value);
    if (isValid) {
      this.errors[name] = "";
    } else {
      this.errors[name] = error;
    }
  }

  async onSaveClick(onSaved: (id: number) => void) {
    var data = {
      id: this.id - 0,
      organization_id: storeList.idMain,
      setting_key: this.setting_key,
      setting_value: this.setting_value,
      data_type: this.data_type,
      description: this.description,
    };

    const { isValid, errors } = await validate(data);
    if (!isValid) {
      this.errors = errors;
      MainStore.openErrorDialog(i18n.t("message:error.alertMessageAlert"));
      return;
    }

    try {
      MainStore.changeLoader(true);
      let response;
      if (this.id === 0) {
        response = await createorganization_setting(data);
      } else {
        response = await updateorganization_setting(data);
      }
      if (response.status === 201 || response.status === 200) {
        onSaved(response);
        if (data.id === 0) {
          MainStore.setSnackbar(i18n.t("message:snackbar.successSave"), "success");
        } else {
          MainStore.setSnackbar(i18n.t("message:snackbar.successEdit"), "success");
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  async doLoad(id: number) {
    this.id = id;

    if (id === null || id === 0) {
      return;
    }

    this.loadorganization_setting(id);
  }

  loadorganization_setting = async (id: number) => {
    try {
      MainStore.changeLoader(true);
      const response = await getorganization_setting(id);
      if ((response.status === 201 || response.status === 200) && response?.data !== null) {
        runInAction(() => {
          this.id = response.data.id;
          this.organization_id = response.data.organization_id;
          this.setting_key = response.data.setting_key;
          this.setting_value = response.data.setting_value;
          this.data_type = response.data.data_type;
          this.description = response.data.description || "";
        });
      } else {
        throw new Error();
      }
    } catch (err) {
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

}

export default new NewStore();